import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from "@/components/DashboardLayout";
import { getNav } from "@/lib/navConfig";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { StatusBadge, UrgencyBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { CreateWorkOrderDialog } from "@/components/CreateWorkOrderDialog";
import { Loader2, ClipboardList, Plus } from "lucide-react";

export default function WorkOrdersList() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isStaff = user.role === "admin" || user.role === "dispatcher";
  const [wos, setWos] = useState(null);
  const [open, setOpen] = useState(false);

  const loadWos = () => api.get("/work-orders").then(({ data }) => setWos(data)).catch(() => setWos([]));
  useEffect(() => { loadWos(); }, []);

  return (
    <DashboardLayout nav={getNav(user.role)} title="Work Orders">
      {isStaff && (
        <div className="flex justify-end mb-4">
          <Button data-testid="create-wo-btn" onClick={() => setOpen(true)} className="bg-blue-600 hover:bg-blue-700">
            <Plus className="w-4 h-4 mr-1.5" /> Create Work Order
          </Button>
        </div>
      )}
      {!wos ? <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-blue-600" /></div> :
        wos.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-xl border border-slate-200" data-testid="wo-empty-state">
            <ClipboardList className="w-12 h-12 text-slate-300 mx-auto" />
            <h3 className="mt-4 font-head text-lg font-semibold text-slate-900">No work orders yet</h3>
            <p className="mt-1 text-slate-500">{isStaff ? "Create your first work order to get started." : "Your work orders will appear here once created."}</p>
            {isStaff && <Button data-testid="empty-create-wo-btn" onClick={() => setOpen(true)} className="mt-5 bg-blue-600 hover:bg-blue-700"><Plus className="w-4 h-4 mr-1.5" /> Create Work Order</Button>}
          </div>
        ) : (
          <div className="space-y-2" data-testid="wo-list">
            {wos.map((w) => (
              <button key={w.id} data-testid={`wo-row-${w.id}`} onClick={() => navigate(`/app/wo/${w.id}`)} className="w-full text-left flex items-center justify-between bg-white border border-slate-200 rounded-xl p-4 hover:border-blue-300 transition-colors">
                <div>
                  <div className="flex items-center gap-2 flex-wrap"><span className="font-medium text-slate-900">{w.wo_number}</span><UrgencyBadge urgency={w.urgency} />{w.job_title && <span className="text-sm text-slate-600">{w.job_title}</span>}</div>
                  <div className="text-sm text-slate-500 mt-0.5">{w.service_category} · {w.property?.name}{w.client?.company_name ? ` · ${w.client.company_name}` : ""}</div>
                </div>
                <StatusBadge status={w.status} />
              </button>
            ))}
          </div>
        )}

      {isStaff && <CreateWorkOrderDialog open={open} onOpenChange={setOpen} onCreated={loadWos} />}
    </DashboardLayout>
  );
}
